import { useContext } from 'react'
import { WizardContext } from '../../generico/CustomStepWizard';
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataTable from 'react-data-table-component';
import { trackPromise } from 'react-promise-tracker';
import PrestamoService from '../../../services/pagos/PrestamoService';
import { Popup } from 'react-leaflet';
import authService from '../../../services/login/auth.service';

const MENSAJE_ERROR_CAMBIO_VENCIMIENTO = "Ha ocurrido un error al cambiar la fecha de vencimiento del crédito. Por favor intente nuevamente o contáctenos.";

export const TrasladoCuotaPaso2 = (props) => {
    const trasladoCuotaContext = useContext(WizardContext);
    const { state, setState } = trasladoCuotaContext;

    const notifiPopup = (titulo,mensaje) =>
    Popup.register({
        title: titulo,
        content: mensaje,
        buttons: {
            right: [
                {
                    text: "Aceptar",
                    className: "success",
                    action: function () {
                        Popup.close();
                    },
                },
            ],
        },
    });

    const obtenerFechaActual = () => {
        const hoy = new Date();
        const dia = String(hoy.getDate()).padStart(2,'0');
        const mes = String(hoy.getMonth() + 1).padStart(2,'0');
        const anio = hoy.getFullYear();
        return `${dia}/${mes}/${anio}`;
    }

    const getColumn = () => {
        return [
            {
                name: "concepto",
                selector: row => row.concepto,
            },
            {
                name: "valor",
                selector: row => row.valor,
            },
        ];
    }

    const getDatosCuenta = () => {
        const respuesta = [
            { concepto: "Crédito N°:", valor: state.credito.cuenta },
            { concepto: "Nro de Cuota:", valor: state.credito.cuotasPagadas+1 },
            { concepto: "Fecha de Vencimiento actual:", valor: state.credito.fechaVencimiento },
            { concepto: "Cambiar fecha de vencimiento a:", valor: state.fechaSeleccionada },
            { concepto: "Diferencia en días:", valor: state.diferenciaDias },
            { concepto: "Impuesto por Interés a pagar:", valor: formatoSeparadorMilesValue(state.interesAPagar) },
            { concepto: "Cuenta a ser debitada:", valor: state.credito.cuenta },
        ];
        return respuesta;
    }

    const confirmarOperacion = () => {
        const numeroLegajo = authService.getBasicSocio().numeroSocio;
        const payload = {
            cuotaHasta : state.credito?.cuotasPagadas + 1,
            fechaEspera : state.fechaSeleccionada,
            fechaProceso : obtenerFechaActual(),
            idCredito : state.credito?.cuenta,
            programa : 'CREA1390_CU24',
            numeroLegajo : Number(numeroLegajo),
            tipo : 2,
            idAhorro : state.ctaFullData?.idAhorro
        }
        trackPromise(
            PrestamoService.cambiarFechaVencimientoCredito(payload)
            .then( ( response ) =>{
                const {codigoRespuesta, mensajeServidor, datos} = response.data;
                if( codigoRespuesta === '0' ){
                    setState({...state,responseCambioVencimiento:datos});
                    props.nextStep();
                }else{
                    Popup.queue(notifiPopup("Info", mensajeServidor));
                }
            })
            .catch( (err) =>{
                Popup.queue(notifiPopup("Info", MENSAJE_ERROR_CAMBIO_VENCIMIENTO));
                console.error(err);
            })
        )
    };

    return (
        <div>
            <div className="row" style={{paddingBottom:20}}>
                <div className="col-md-12">
                    <label className="input-label-bold">Verificá todos los datos antes de confirmar</label>
                </div>
            </div>
            <div className="row" style={{marginTop:15,marginBottom:25}}>
                <div className="col-lg-12">
                    <div className="row justify-content-md-center">
                        <div className="col-lg-7 col-md-10">
                            <div className="row">
                                    <DataTable
                                        noHeader={true}
                                        columns={getColumn()}
                                        data={getDatosCuenta()}
                                        dense={true}
                                        noDataComponent="No hay registros para mostrar"
                                        responsive={true}
                                        noTableHead={true}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* FOOTER */}
            <div className="row">
                <div className="col-lg-8 col-md-6">
                    <label className="input-label-bold">
                        ¿Está seguro que desea CONFIRMAR la operación?
                        <br />
                    </label>
                </div>
                <div className="col-lg-2 col-md-3">
                        <button
                            className="btn btn-cu-quintary btn-consulta"
                            onClick={props.previousStep}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} /> Volver
                        </button>
                </div>
                <div className="col-lg-2 col-md-3">
                        <button
                            className="btn btn-cu-primary"
                            onClick={confirmarOperacion}
                        >
                            Confirmar <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                </div>
            </div>
        </div>
    )
}
